const sexDict = [
    {
        id: '0', name: '未设定'
    },
    {
        id: '1', name: '男'
    },
    {
        id: '2', name: '女'
    }
]

const userStatusDict = [
    {
        id: 0,name: '未授权'
    },
    {
        id: 1,name: '申请授权中'
    },
    {
        id: 2,name: '已授权'
    },
    {
        id: 4,name: '已禁用'
    },
    {
        id: 6,name: '管理员权限'
    }
]

const wdTypeDict = [
    {
        id: 1,name: '普通版'
    },
    {
        id: 2,name: '加强版'
    }
]

export {
    sexDict,
    userStatusDict,
    wdTypeDict
}


// WEBPACK FOOTER //
// ./src/utils/dict.js